<script setup>
defineProps({
  ambiti: {
    type: Array,
    default: () => [],
  },
  settoriText: {
    type: String,
    default: '',
  },
  servizioSuggerito: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<template>
  <div class="end-page-section row-40-20 p-top-7">
    <div class="row-80 max">
      <div class="container">
        <div v-if="ambiti.length > 0" class="left-section">
          <div class="ambiti-di-intervento">
            <h2 class="heading-3">Ambiti di intervento</h2>
            <div class="text-2">
              <ul class="list">
                <li
                  v-for="(item, index) in ambiti"
                  :key="index"
                  class="ambito"
                  :class="{ 'last-element': index === ambiti.length - 1 }"
                >
                  <nuxt-link
                    v-if="item.slug"
                    class="text-3"
                    :to="
                      $localePath({
                        name: 'ambiti-slug',
                        params: { slug: item.slug },
                      })
                    "
                  >
                    <div v-if="item.titolo" class="icon-link-animation">
                      {{ item.titolo }}
                      <img
                        src="@/assets/img/ico/arrows.svg"
                        alt="Icon"
                        class="icon"
                      />
                    </div>
                  </nuxt-link>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="servizioSuggerito" class="suggested">
            <!-- eslint-disable vue/no-v-html -->
            <h2
              v-if="servizioSuggerito.titolo"
              class="heading-3"
              v-html="servizioSuggerito.titolo"
            />
            <div
              v-if="servizioSuggerito.testo"
              class="text-2 testo"
              v-html="servizioSuggerito.testo"
            />
            <div class="end-page-btn">
              <MainButton
                :text="servizioSuggerito.cta.testo"
                :url="servizioSuggerito.cta.link"
                :internal-link="true"
                :is-black="false"
                :is-blue="true"
              />
            </div>
          </div>
        </div>

        <div class="right-section">
          <div class="dettaglio">
            <h2 v-if="settoriText" class="heading-3" v-html="settoriText" />
            <div class="text-2">
              <ul class="list">
                <li>Consulenza</li>
                <li>Servizi</li>
                <li>Finanza</li>
                <li>Assicurazioni</li>
                <li>Manifattura</li>
                <li>Retail</li>
                <li>Tecnologia</li>
                <li>Sanità - Pharma</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EndPageSection',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
